import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxUnderlineComponent } from './phx-underline.component';

@NgModule({
  declarations: [ PhxUnderlineComponent ],
  imports: [ CommonModule ],
  exports: [ PhxUnderlineComponent ],
})
export class PhxUnderlineModule { }
